<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen';
import BoConfig from '@config/BoConfig';

export default {
  extends: Base,
  data(){
    return {
      Name:"AuditTrail",
      PageName: "Audit Trail List",
      ObjectName: "Audit Trail",
      row: {},
      WithLimit: true,
      mrValidation: {},
      input: {}
    }
  },
  computed:{
    mrAccessMenu(){ return BoConfig.mrAccessMenu },
    mrAccessModule(){ return BoConfig.mrAccessModule },
  },
  mounted(){
    this.$set(this.$root, 'page', this)
    this.refreshData()

    if(!this.filter.startdate && !this.filter.enddate && !this.filter.search){
      this.storeAuditTrail()
    }
  },
  methods:{
    onRefreshPage(){

    },
    successFormCallback(resp){
      return Gen.info(resp.message, "success", 1000).then(()=>{
        this.refreshVariable()
        this.$router.push({name:this.Name})
      })
    },
    onSubmitForm(e){
      this.submitForm(e)
    },
    storeAuditTrail(){
      BOGen.apirest("/save-audit-trail-data", {
        applicationName: "Employee Facility System",
        cwid: this.user.cwid,
        functionName: "Open Menu",
        description: "Open Menu Audit Trail"
      }, (err, resp)=>{
        if(err) console.error(err)

        this.refreshData()
      }, "POST")
    },
  },
  watch:{
    '$route.query'(v){
      this.refreshData()
    },
    'filter.startdate'(v){
      if(global.moment(this.filter.startdate,'DD-MM-YYYY').isAfter(global.moment(this.filter.enddate,'DD-MM-YYYY')) || !this.filter.enddate) this.$set(this.filter, 'enddate', this.filter.startdate)
      this.search()
    },
    'filter.enddate'(v,b){
      if(global.moment(this.filter.startdate,'DD-MM-YYYY').isAfter(global.moment(this.filter.enddate,'DD-MM-YYYY')) || !this.filter.startdate) this.$set(this.filter, 'startdate', this.filter.enddate)
      if(b) this.search()
    }
  }
}
</script>

<template>
  <div class="container-fluid">
    <PageTitle :listOnly="$route.meta.listOnly"></PageTitle>
    
    <!-- ======================================================================== 
      LIST DATA
    ============================================================================= -->
    <div class="card card-flat" v-if="!$route.params.id">
      <div class="card-body card-filter">
        <VForm @resp="search">
          <div class="row">
            <div class="col-sm-3">
              <h4 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h4>
            </div>
            <div class="col-sm-4">
              <div class="input-daterange input-group">
                <DatePicker v-model="filter.startdate" :config="{startDate:'-2y'}" @keyup.enter="search" placeholder="Start Date"></DatePicker>
                <div class="input-group-append">
                  <span class="input-group-text bg-info b-0 text-white">TO</span>
                </div>
                <DatePicker v-model="filter.enddate" :config="{startDate:'-2y'}" @keyup.enter="search" placeholder="End Date"></DatePicker>
              </div>
            </div>
            <div class="col-sm-2">
              <Select2 :options="BoConfig.mrPageLimit" v-model="filter.limit" @input="changeLimit"></Select2>
            </div>
            <div class="col-sm-2">              
              <div class="has-feedback has-feedback-left">
                  <input type="search" v-model="filter.search" class="form-control" placeholder="Type and hit Enter">
                  <div class="form-control-feedback">
                  <i class="icon-search4 text-size-base text-muted"></i>
                  </div>
              </div>              
            </div>
            <div class="col-sm-1">
              <button type="button" @click="resetSearch()" class="btn btn-warning btn-sm">Reset</button>
            </div>
          </div>
        </VForm>
      </div>
      <div class="table-responsive ajax-table">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th width="50px">#</th>
              <th>{{fields.functionName}}</th>
              <th>{{fields.description}}</th>
              <th>{{fields.cwid}}</th>
              <th><SortField name="date" :label="fields.date"></SortField></th>
              <th width="120px">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v,k) in data.data" :key="k">
              <td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
              <td>{{v.functionName}}</td>
              <td>{{v.description}}</td>
              <td>{{v.cwid}}</td>
              <td>{{(v.date||"").dates("format2")}}</td>
              <td class="btn-action">
                <router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Edit'"><i class="ti-eye"></i></router-link>
              </td>
            </tr>
            <tr v-if="NotFound">
              <td colspan="99">
                <h3 class="tc">{{NotFound}}</h3>
              </td>
            </tr>
            <tr v-if="data.data===false">
              <td colspan="99">
                <LoadingSpinner light></LoadingSpinner>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-body">
        <div class="pull-right">
          <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
        </div>
      </div>
    </div>

    <!-- ======================================================================== 
      FORM CRUD
    ============================================================================= -->
    <div class="card card-flat" v-if="$route.params.id">
      <div class="card-body">
        <router-link class="btn btn-outline-info btn-sm mb-3" :to="{ name: 'AuditTrail' }">
          <i class="icon-arrow-left mr-1"></i>
          Back to Audit Trail List
        </router-link>
        <div class="row">
          <div class="col-md-12">
            <div class="row row-gutter">
              <div class="col-md-4">
                <div class="detail-info">
                  <strong>CWID</strong>
                  <span>{{ row.cwid || "-"}}</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="detail-info">
                  <strong>Function Name</strong>
                  <span>{{ row.functionName || "-"}}</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="detail-info">
                  <strong>IP Address</strong>
                  <span>{{ row.iPAddress || "-"}}</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="detail-info">
                  <strong>Description</strong>
                  <span>{{ row.description || "-"}}</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="detail-info">
                  <strong>Date</strong>
                  <span>{{ moment(row.date).format('DD MMMM YYYY') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
